import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDebounceCallback } from "@/hooks";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { getFullPath, routes } from "../../routes";

export function GlobalSearchField() {
  const [value, setValue] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const debouncedSearch = useDebounceCallback(search, 500);

  useEffect(() => {
    // Reset search field when leaving the search page.
    if (location.pathname !== getFullPath(routes.miscellaneous.search)) {
      setValue("");
    }
  }, [location.pathname]);

  function handleSearch(query: string) {
    setValue(query);
    debouncedSearch(query);
  }

  function search(query: string) {
    const params = new URLSearchParams({ search: query });
    navigate(`williams/search?${params}`);
  }

  return (
    <div className="input-group me-5 my-auto">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={value}
        onChange={(e) => handleSearch(e.target.value)}
      />
      <span className="input-group-text" role="button">
        <FontAwesomeIcon size="sm" icon={faMagnifyingGlass} title="Search" />
      </span>
    </div>
  );
}
